import { Col, Container, Row } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Spinner } from "@amzn/stencil-react-components/spinner";
import { Text } from "@amzn/stencil-react-components/text";
import { withTooltip } from "@amzn/stencil-react-components/tooltip";
import { IconQuestionCircle } from "@amzn/stencil-react-icons";
import ListModalButton, { LIST_MODAL_TYPE } from "common/components/ListModal/ListModalButton";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { ListType } from "common/context/lists";
import { useLists } from "common/context/lists/ListsContext";
import { getJobFamilyFromRule } from "common/helpers/lists-helper";
import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { Visibility } from "lib/models/list-models";
import { UserPermissions } from "lib/services";
import React, { FC, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { List } from "../List";
const ListsAdminPage: FC = () => {
  const history = useHistory();
  const { publicLists, loading, getPublicLists } = useLists();

  const adminLists = UserPermissions.current.hasPermission(PERMISSIONS.AIFORME_ADMIN_LISTS);

  useEffect(() => {
    getPublicLists({ includeItemDetails: true });
  }, [adminLists]);

  if (!adminLists) {
    history.push("/");
    return null;
  }
  const IconWithTooltip = withTooltip()(IconQuestionCircle);

  return (
    <Col>
      <PageMainContainer>
        <Container paddingTop={32} paddingBottom={32}>
          <Col gridGap={32}>
            <Row justifyContent="space-between">
              <Text fontSize="T400" fontWeight="bold">
                {getString("lists.admin.title")}
              </Text>
              <ListModalButton
                type={LIST_MODAL_TYPE.ADMIN}
                jobFamilies={publicLists
                  .map((list) => getJobFamilyFromRule(list.evaluationRules))
                  .filter((jobFamily): jobFamily is string => jobFamily !== undefined)}
              />
            </Row>
            <Row>
              <Text fontSize="T200" style={{ whiteSpace: "pre-line" }}>
                {getString("lists.admin.description")}
              </Text>
              <IconWithTooltip
                tooltipText={
                  <Text>
                    {getString("lists.admin.tooltip.message")}
                    <Link href={getString("lists.admin.tooltip.linkUrl")} target="_blank">
                      {getString("lists.admin.tooltip.linkText")}
                    </Link>
                  </Text>
                }
                color="primary70"
              />
            </Row>

            <Col gridGap="S300">
              {loading && <Spinner />}
              {!loading &&
                publicLists.map(
                  (list, index) =>
                    list.visibility == Visibility.PUBLIC && (
                      <List
                        listType={ListType.PUBLIC_LISTS}
                        isAdmin
                        allowEdit={list.ownerAlias === UserPermissions.current.username}
                        key={`List-${index}`}
                        {...list}
                      />
                    )
                )}
              {!loading && publicLists.filter((list) => list.visibility == Visibility.PUBLIC).length == 0 && (
                <Text fontSize="T200">{getString("lists.noLists")}</Text>
              )}
            </Col>
          </Col>
        </Container>
      </PageMainContainer>
    </Col>
  );
};

export default ListsAdminPage;
